'use strict'

export const LIVE_PORTRAIT_RATIO = 9 / 16
export const LIVE_LANDSCAPE_RATIO = 16 / 9

export function getLiveStreamOrientation(stream) {
  if (!stream) return 'portrait'

  const orientation = typeof stream.get === 'function'
    ? stream.get('stream_orientation')
    : stream.stream_orientation

  if (orientation === 'landscape') return 'landscape'
  if (orientation === 'portrait') return 'portrait'

  return 'portrait'
}

export function getLiveStreamAspectRatio(stream) {
  return getLiveStreamOrientation(stream) === 'landscape'
    ? LIVE_LANDSCAPE_RATIO
    : LIVE_PORTRAIT_RATIO
}

export function getLiveStreamFrameStyles(stream) {
  const orientation = getLiveStreamOrientation(stream)
  const aspectRatio = getLiveStreamAspectRatio(stream)

  if (orientation === 'landscape') {
    return {
      aspectRatio: `${aspectRatio}`,
      width: '100%',
      maxWidth: 'min(100%, calc(100vh * 1.7778))',
      maxHeight: 'calc(100vh - 24px)',
    }
  }

  return {
    aspectRatio: `${aspectRatio}`,
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
  }
}
